import {HttpService} from "../technique/http.service";
import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {PointFacturationDto} from "../../dtos/facturation/clients/points-facturation/point-facturation-dto";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {GraphQLService} from "../technique/graphql.service";
import {Auth2Service} from "../security/auth2.service";
import {catchError, map} from "rxjs/operators";
import {UtilsService} from "../../utils/utils.service";
import {saveAs as fs_saveAs} from "file-saver";
import {FactureClientDto} from "../../dtos/facturation/clients/factures/facture-client-dto";
import {GenerateFactureClientDto} from "../../dtos/facturation/clients/factures/generate-facture-client-dto";
import {FactureClientSettingsML} from "../../dtos/facturation/clients/factures/facture-client-settings-ml";
import {FactureClientErrorsDto} from "../../dtos/facturation/clients/factures/facture-client-errors-dto";
import {LigneParametrageFacturation} from "../../models/facturation/client/ligne-parametrage-facturation";
import {
  ParametersGenerationLignesParametrage
} from "../../models/facturation/client/parameters-generation-lignes-parametrage";
import {
  LigneParametrageFacturationChanges
} from "../../models/facturation/client/ligne-parametrage-facturation-changes";
import {TransfertHeadcountSettingsModel} from "../../models/facturation/transfert-headcount-settings-model";
import {FilterExportAnalyseFinanciere} from "../../models/facturation/client/filter-export-analyse-financiere";
import {AnalyseFinanciereDetail} from "../../models/facturation/client/analyse-financiere-detail";

@Injectable({
  providedIn: 'root'
})
export class FacturationClientService {

  dataAnalysePlat: AnalyseFinanciereDetail[] = [];
  dataAnalysePrestation: AnalyseFinanciereDetail[] = [];

  private subjectOpenDialogTransfertEffectives = new Subject<PointFacturationDto>();
  openDialogTransfertEffectives$ = this.subjectOpenDialogTransfertEffectives.asObservable();

  private subjectOpenDialogEditionPointFacturation = new Subject<PointFacturationDto>();
  openDialogEditionPointFacturation$ = this.subjectOpenDialogEditionPointFacturation.asObservable();

  private subjectPointFacturationSaved = new Subject<PointFacturationSavedSupplier>();
  pointFacturationSaved$ = this.subjectPointFacturationSaved.asObservable();

  private subjectOpenDialogDetailsFactureClient = new Subject<GenerateFactureClientSupplier>();
  openDialogDetailsFactureClient$ = this.subjectOpenDialogDetailsFactureClient.asObservable();

  private subjectFactureClientCreated = new Subject<FactureClientDto>();
  factureClientCreated$ = this.subjectFactureClientCreated.asObservable();

  private subjectFactureClientErrors = new Subject<[FactureClientErrorsDto]>();
  factureClientErrors$ = this.subjectFactureClientErrors.asObservable();

  private subjectFactureClientPrint = new Subject<FactureClientDto[]>();
  factureClientPrint$ = this.subjectFactureClientPrint.asObservable();

  private subjectOpenExportSettings: Subject<number> = new Subject<number>();
  openExportSettings$ = this.subjectOpenExportSettings.asObservable();

  private subjectExportAnalyseFinancierePlat: Subject<AnalyseFinanciereDetail[]> = new Subject<[]>();
  exportAnalyseFinancierePlat$: Observable<AnalyseFinanciereDetail[]> = this.subjectExportAnalyseFinancierePlat.asObservable();

  private subjectExportAnalyseFinancierePrestation: Subject<AnalyseFinanciereDetail[]> = new Subject<AnalyseFinanciereDetail[]>();
  exportAnalyseFinancierePrestation$: Observable<AnalyseFinanciereDetail[]> = this.subjectExportAnalyseFinancierePrestation.asObservable();

  constructor(private httpSvc: HttpService,
              private auth2Svc: Auth2Service,
              private graphQlSvc: GraphQLService,
              private httpClient: HttpClient,
              private utils: UtilsService) {
  }

  announceExportAnalyseFinancierePlat = (analyseFinancierePlat: AnalyseFinanciereDetail[]) => {
    this.subjectExportAnalyseFinancierePlat.next(analyseFinancierePlat);
  }

  announceExportAnalyseFinancierePrestation = (analyseFinancierePrestation: AnalyseFinanciereDetail[]) => {
    this.subjectExportAnalyseFinancierePrestation.next(analyseFinancierePrestation);
  }

  announceOpenDialogEditionPointFacturation = (pointFacturation: PointFacturationDto) => {
    this.subjectOpenDialogEditionPointFacturation.next(pointFacturation);
  };

  announceOpenExportSettings = (currentIndex: number): void => {
    this.subjectOpenExportSettings.next(currentIndex);
  }

  announcePointFacturationSaved = (pointFacturation: PointFacturationDto, isUpdate: boolean = false) => {
    this.subjectPointFacturationSaved.next({isUpdate, pointFacturation} as PointFacturationSavedSupplier);
  }

  announceOpenDialogDetailsFactureClient = (generateFactureClient: GenerateFactureClientDto, factureClient: FactureClientDto) => {
    this.subjectOpenDialogDetailsFactureClient.next({generateFactureClient, factureClient});
  };

  announceFactureClientCreated = (factureClient: FactureClientDto) => {
    this.subjectFactureClientCreated.next(factureClient);
  }

  announceFactureClientErrors = (factureClientErrors: [FactureClientErrorsDto]) => {
    this.subjectFactureClientErrors.next(factureClientErrors);
  }

  printFactureClient = (printSettingsList: FactureClientSettingsML[]): void => {
    if (printSettingsList.length === 1) {
      this.httpClient.post(`dolrest/facturation-client/print-pdf`, printSettingsList, {responseType: 'arraybuffer'})
        .subscribe(response => {
          const blob = new Blob([response], {type: 'application/pdf'});
          fs_saveAs(blob, `facture-client-${printSettingsList[0].id}-${new Date().getTime()}.pdf`);
        });
    } else if (printSettingsList.length > 1) {
      this.httpClient.post(`dolrest/facturation-client/print-pdf`, printSettingsList, {responseType: 'arraybuffer'})
        .subscribe(response => {
          const blob = new Blob([response], {type: 'application/zip'});
          fs_saveAs(blob, `factures-clients-${new Date().getTime()}.zip`);
        });
    }
  };

  announceOpenPrintSettings = (factureClientList: FactureClientDto[]) => {
    this.subjectFactureClientPrint.next(factureClientList);
  }

  announceOpenDialogTransfertEffectives = () => {
    this.subjectOpenDialogTransfertEffectives.next();
  }

  findAllPointsFacturation = (plcLabel: string): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
          allPointsFacturation(filters: {
          siteIds: [${this.auth2Svc.utilisateur.sites.map(s => s.id)}],
          ${(plcLabel != null && plcLabel !== "") ? `plcLabel: "${plcLabel}",` : ""}
        }) {
          ${PointFacturationDto.getAllProperties()}
        }
      }
    `).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  savePointFacturation = (pointFacturation: PointFacturationDto) => {
    return this.httpSvc.post(`dolrest/point-facturation/save`, pointFacturation).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  deletePointFacturation = (ids: number[]) => {
    const params: HttpParams = new HttpParams().set('idsToDelete', ids.join(','));
    return this.httpSvc.delete(`dolrest/point-facturation/delete`, params).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  deleteFactureClient = (ids: number[]) => {
    const params: HttpParams = new HttpParams().set('idsToDelete', ids.join(','));
    return this.httpSvc.delete(`dolrest/facturation-client/delete`, params).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  validateFactureClient = (ids: number[]) => {
    const params: HttpParams = new HttpParams().set('idsToValidate', ids.join(','));
    return this.httpSvc.post(`dolrest/facturation-client/validate`, params).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  findAllFacturesClient = (): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
          allFacturesClient(filters: {
          siteIds: [${this.auth2Svc.utilisateur.sites.map(s => s.id)}],
        }) {
          ${FactureClientDto.getAllProperties()}
        }
      }
    `).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  findAllLignesParametrage = (): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
          allLignesParametrageFacturation {
          ${LigneParametrageFacturation.getAllGraphQlProperties()}
        }
      }
    `).pipe(
      catchError(error => this.utils.handleError(error, true)),
      map(result => result ? result.allLignesParametrageFacturation : result)
    );
  }

  findLigneParametrageHierarchy = (): Observable<any> => {
    return this.httpSvc.get(`dolrest/facturation-client/parametrage/hierarchy`);
  }

  generateFactureClient = (generateFactureClient: GenerateFactureClientDto) => {
    return this.httpSvc.post(`dolrest/facturation-client/generate`, generateFactureClient).pipe(
      catchError(error => this.utils.handleError(error, true))
    )
  }

  saveLignesParametrage = (changes: LigneParametrageFacturationChanges): Observable<any> => {
    return this.httpSvc.post(`dolrest/facturation-client/parametrage/save`, {
      lignesToAdd: changes.toAdd,
      lignesToEdit: changes.toEdit,
      ligneIdsToDelete: changes.toDelete
    });
  }

  prepareLignesParametrageToAdd = (properties: ParametersGenerationLignesParametrage) => {
    return this.httpSvc.post(`dolrest/facturation-client/parametrage/generate-lines`, properties);
  }

  transfertEffectives(ransfertEffectivesSettingsModel: TransfertHeadcountSettingsModel) {
    return this.httpSvc.post(`dolrest/facturation-client//effectif/transfert`, ransfertEffectivesSettingsModel);
  }

  exportAnalyseFinancierePrestation(filter: FilterExportAnalyseFinanciere): Observable<Object> {
    const dateDebut =  this.utils.transformDateToString(filter.dateDebut, 'YYYY-MM-DD')
    const dateFin =  this.utils.transformDateToString(filter.dateFin, 'YYYY-MM-DD')
    const params = new HttpParams()
      .set('dateDebut', dateDebut)
      .set('dateFin', dateFin)
      .set('idsPointDeFacturation', filter.idsPointDeFacturation?.join(',') || '')
      .set('idsPointDeLivraison', filter.idsPointDeLivraison?.join(',') || '')
      .set('idsPrestation', filter.idsPrestation?.join(',') || '')
      .set('idsRepas', filter.idsRepas?.join(',') || '')
      .set('idsRegime', filter.idsRegime?.join(',') || '');
    return this.httpClient.get(`dolrest/facturation-client/export-analyse-financiere-prestation`, {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    });
  }

  exportAnalyseFinancierePlat(filter: FilterExportAnalyseFinanciere) {
    const dateDebut =  this.utils.transformDateToString(filter.dateDebut, 'YYYY-MM-DD')
    const dateFin =  this.utils.transformDateToString(filter.dateFin, 'YYYY-MM-DD')
    const params = new HttpParams()
      .set('dateDebut', dateDebut)
      .set('dateFin', dateFin)
      .set('idsPointDeLivraison', filter.idsPointDeLivraison?.join(',') || '')
      .set('idsPrestation', filter.idsPrestation?.join(',') || '')
      .set('idsRepas', filter.idsRepas?.join(',') || '')
      .set('idsRegime', filter.idsRegime?.join(',') || '');
    return this.httpClient.get(`dolrest/facturation-client/export-analyse-financiere-plat`, {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    });
  }

  findLigneExportPlatHierarchy(): Observable<any> {
    return this.httpSvc.get(`dolrest/facturation-client/parametrage/hierarchy-plat`);
  }
}

export interface PointFacturationSavedSupplier {
  isUpdate: boolean;
  pointFacturation: PointFacturationDto;
}

export interface GenerateFactureClientSupplier {
  generateFactureClient: GenerateFactureClientDto;
  factureClient: FactureClientDto;
}
